import { useEffect, useState } from 'react';
import { TableColumn } from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useGetSuperadmins, useUpdateSystemUserRole } from "../../api/UserApi";
import { Icon } from "../../assets/Icons/IconClassNames";
import ContentContainer from "../../components/ContainerComponents/ContentContainer";
import CustomDropdown, { DropdownToggleType } from "../../components/CustomDropdown/CustomDropdown";
import { CustomDropdownItem } from "../../components/CustomDropdown/CustomDropdownItem/CustomDropdownItem";
import PaginatedDataTableClientSide from "../../components/DataTableComponents/PaginatedDataTable";
import SimpleConfirmModal from "../../components/ModalComponents/SimpleConfirmModal";
import When from "../../components/When";
import { Role } from "../../core/enums/enums";
import { IUserResponse } from "../../core/interfaces/user";
import styles from "../Users/Users.module.scss";
import NewSuperadminModal from "./NewSuperadminModal";
import { useGetUser } from "../../hooks/useAuth";

const SuperadminTable = () => {
    const user = useGetUser();
    const {t} = useTranslation();
    const [openNewSuperadminModal, setOpenNewSuperadminModal] = useState(false);
    const [data, loading] = useGetSuperadmins();
    const [showRemoveUserModal, setShowRemoveUserModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState<IUserResponse | null>(null);
    const [update, isUpdating] = useUpdateSystemUserRole(selectedUser?.id ?? "");
    const [nrOfActiveSuperAdmins, SetNrOfActiveSuperAdmins] = useState<number>(0);
    const [copyEmailAddressesStatus, SetCopyEmailAddressesStatus] = useState<string>();
    const [copyEmailAddressesStatusColor, SetCopyEmailAddressesStatusColor] = useState<string>("green");

    const IsSuperAdmin = (): boolean => {
        return user.role === Role.SUPERADMIN;
    };

    // useEffect(() => {
    //     // Get email adresses for active users
    //     if (!data) return;
    //     if (loading) return;

    //     const emails = data
    //         .filter(user => user.isActiveInAnyCompany)
    //         .map(user => user.email);

    //     var emailString = emails.join(';');

    //     navigator.clipboard.writeText(emailString)
    //         .then(() => { 
    //             console.log(t('SuperadminTable.COPY_DATA_SUCCESS_MESSAGE'), emailString);
    //             SetCopyEmailAddressesStatus(emails.length + ' ' + t('SuperadminTable.COPY_DATA_SUCCESS_MESSAGE'));
    //             SetCopyEmailAddressesStatusColor("green");
    //         })
    //         .catch(err => {
    //             console.log("Active User Emails: ", emailString);
    //             SetCopyEmailAddressesStatus(t('SuperadminTable.COPY_DATA_ERROR_MESSAGE'));
    //             SetCopyEmailAddressesStatusColor("red");
    //         });

    //     SetNrOfActiveSuperAdmins(emails.length);

    // }, [loading, data]);

    const columns: TableColumn<IUserResponse>[] = [
        {
            name: t('SuperadminTable.NAME_1'),
            selector: row => `${row.person.firstName} ${row.person.lastName}`,
            sortable: true,
        },
        {
            name: t('SuperadminTable.E_MAIL_1'),
            selector: row => row.email,
            sortable: true,
        },
        {
            name: t("SuperadminTable.IN_ACTIVE_COMPANY"),
            selector: row => row.isActiveInAnyCompany ? t("SuperadminTable.YES_1") : t("SuperadminTable.NO"),
            sortable: true
        },
        {
            name: <span className={styles.clickable} onClick={() => setOpenNewSuperadminModal(true)}>{t('SuperadminTable.ADD_SUPERADMIN_1')}</span>,
            right: true,
            cell: row => (
                <CustomDropdown toggleType={DropdownToggleType.GEAR}>
                    <CustomDropdownItem
                        icon={Icon.REMOVE}
                        text={t('SuperadminTable.REMOVE_AS_SUPERADMIN_1')}
                        onClick={() => {
                            setSelectedUser(row)
                            setShowRemoveUserModal(true)
                        }}
                    />
                </CustomDropdown>
            )
        }
    ];

    const handleUpdate = async () => {
        if (!selectedUser) return;
        //setting to USER for future alternatives
        await update(Role.USER);
        setSelectedUser(null);
        setShowRemoveUserModal(false);
    }


    return (
        <ContentContainer>

            {IsSuperAdmin() && data && !loading && (
                <div className='text-center col' style={{ color: copyEmailAddressesStatusColor }}>{copyEmailAddressesStatus}</div>
            )}

            {/*-Alternative for adding-*/}

            {/*<div className="ps-2 pb-2">*/}
            {/*    <ClickableIconButton*/}
            {/*        disabled={false}*/}
            {/*        buttonType={"EDIT"}*/}
            {/*        icon={getIcon(Icon.CIRCLE_PLUS, IconSize.X2)}*/}
            {/*        onClick={() => setOpenNewSuperadminModal(true)}*/}
            {/*        title={t('SuperadminTable.ADD_SUPERADMIN_2')}*/}
            {/*    />*/}
            {/*</div>*/}
            <PaginatedDataTableClientSide
                data={data ?? []}
                progressPending={false}
                columns={columns}
                usePagination={!IsSuperAdmin()}
            />

            <NewSuperadminModal show={openNewSuperadminModal} hide={() => setOpenNewSuperadminModal(false)}/>
            <When condition={!!selectedUser && showRemoveUserModal}>
                <SimpleConfirmModal
                    show={showRemoveUserModal}
                    header={<>{t('SuperadminTable.DELETE_SUPER_ADMINISTRATOR_1')}</>}
                    text={<>{t('SuperadminTable.CONFIRM_1')}</>}
                    onClickOKText={t('SuperadminTable.YES_1')}
                    onClickOK={handleUpdate}
                    isLoadingClickOk={isUpdating}
                    onClickCancelText={t('SuperadminTable.CANCEL_1')}
                    onClickCancel={() => {
                        setShowRemoveUserModal(false);
                        setSelectedUser(null);
                    }}
                />
            </When>
        </ContentContainer>
    );
};

export default SuperadminTable;
